// React
import { createContext } from "react"

// Types
import type { UploadType } from "../types"

export const UploadContext = createContext<{
  onSuccess: () => void
  handleSaveFileExcel: () => Promise<UploadType>
}>({
  onSuccess() {},
  handleSaveFileExcel() {
    return Promise.resolve({
      data: [],
      identity_batch: ""
    })
  }
})